module.exports = __webpack_public_path__ + "img/ucelinklogo-5.d8931faa.jpg";